import { Edit } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";
import type { Portfolio } from "global-types";

interface EditPropertyTriggerProps {
  propertyId: string;
  portfolios: Portfolio[];
  onPropertyUpdated?: () => void;
}

export const EditPropertyTrigger = ({
  propertyId,
  portfolios,
  onPropertyUpdated,
}: EditPropertyTriggerProps) => {
  if (onPropertyUpdated) {
    (window as any).__propertyUpdatedCallback = onPropertyUpdated;
  }

  return (
    <ModalTrigger
      modalPath={`/modals/property/${propertyId}/edit`}
      modalState={{ propertyId, portfolios }}
      className="cursor-pointer w-6 h-6"
      size="icon"
      title="Edit Property"
    >
      <Edit className="w-3 h-3" />
    </ModalTrigger>
  );
};
